import toast from 'react-hot-toast'
import { QueryFunctionContext, useInfiniteQuery } from 'react-query'
import last from 'lodash/last'
import { SortingRule } from 'react-table'

import { customersPerPage } from '../utils/config'
import customerService from '../services/customerService'
import { Customer } from '../types/customer'
import { BuzzlUsersError } from '../types/buzzl-user'

export function useCustomers(params: { [x: string]: any }, orderBy?: SortingRule<Customer>[]) {
  return useInfiniteQuery(
    ['customers', params, orderBy],
    (context: QueryFunctionContext) => {
      return customerService.getAll(params, {
        first: customersPerPage,
        after: context.pageParam || '',
        ...(orderBy && orderBy.length > 0
          ? { orderBy: `${orderBy[0].id}_${orderBy[0].desc ? 'DESC' : 'ASC'}` }
          : { orderBy: 'createdAt_DESC' }),
      })
    },
    {
      keepPreviousData: true,
      getNextPageParam: (lastPage) => {
        if (lastPage.length < customersPerPage) return undefined
        const lastItem = last(lastPage)

        return lastItem?.id
      },
      onError: (e) => {
        const error = e as BuzzlUsersError
        error.response.errors.map((er) =>
          toast.error(er.message || 'Something went wrong, if the error persist please contact support.')
        )
      },
    }
  )
}
